import { render, staticRenderFns } from "./TreineBanner.vue?vue&type=template&id=4620d7c9&scoped=true&"
import script from "./TreineBanner.vue?vue&type=script&lang=js&"
export * from "./TreineBanner.vue?vue&type=script&lang=js&"
import style0 from "./TreineBanner.vue?vue&type=style&index=0&id=4620d7c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620d7c9",
  null
  
)

export default component.exports